export default class CourseOfferingsModel {
  constructor(courseOffering) {
    this.courseId = courseOffering.courseId;
    this._courseOfferingId = courseOffering.courseOfferingId;
    this._canvasCourseId = courseOffering.canvasCourseId || null;
    this._courseDescription = courseOffering.courseDescription;
    this._courseOfferingName = courseOffering.name;
    this._courseType = courseOffering.courseType;
    this._coursePrefix = courseOffering.coursePrefix;
    this._courseOfferingActive = courseOffering.courseIsActive;
    this._courseTooltip = courseOffering.courseTooltip;
    this._term = courseOffering.term;
    this._sessionName = courseOffering.sessionName;
    this._asuCredits = +courseOffering.asuCredits;
    this._courseEndDate = courseOffering.courseEndDate;
    this._courseStartDate = courseOffering.courseStartDate;
    this._courseUrl = courseOffering.courseUrl;
    this._eaCourseUrl = courseOffering.eaCourseURL;
  }
}
